<template>
  <div class="h-100 d-block">
    <b-table-simple
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      small
    >
      <b-thead>
        <b-tr>
          <b-th
            rowspan="2"
            class="align-middle"
          >
            Gayrimenkul Tipi
          </b-th>
          <b-th
            rowspan="2"
            class="align-middle text-center"
          >
            Toplam Adet
          </b-th>
          <b-th
            rowspan="2"
            class="align-middle text-center"
          >
            Satılan Adet
          </b-th>
          <b-th
            rowspan="2"
            class="align-middle text-center"
          >
            Kalan Adet
          </b-th>
          <b-th
            rowspan="2"
            class="align-middle text-center"
          >
            Vade Gün (Ortalama)
          </b-th>
          <b-th
            rowspan="2"
            class="align-middle text-center"
          >
            Görüşme Adet
          </b-th>
          <b-th
            class="text-center"
            colspan="3"
          >
            Durum Kodlarına Göre Devam Eden Görüşmeler
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="text-center">
            A / Adet
          </b-th>
          <b-th class="text-center">
            B / Adet
          </b-th>
          <b-th class="text-center">
            C / Adet
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(item,key) in dataList"
          :key="key"
        >
          <b-td>
            {{ item.name }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.stockCount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.saleCount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.saleableCount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.dueDates | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.interviewCount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.statusACount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.statusBCount | toNumber }}
          </b-td>
          <b-td class="text-center align-middle">
            {{ item.data.statusCCount | toNumber }}
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th>Genel Toplam</b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.stockCount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.saleCount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.saleableCount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.dueDates | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.interviewCount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.statusACount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.statusBCount | toNumber }}
          </b-th>
          <b-th class="text-center align-middle">
            {{ grandTotals.statusCCount | toNumber }}
          </b-th>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>
<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd, BTfoot,
} from 'bootstrap-vue'

export default {
  name: 'OverviewTable',
  components: {
    BTableSimple, BThead, BTr, BTh, BTbody, BTd, BTfoot,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
}
</script>
